export enum ModuleType {
    OptionsTable = 1,
    PositionsAndOrders = 2,
    BalanceProfile = 3,
    ParametersProfile = 4,
    PortfolioBalancer = 5,
    BalanceHistory = 6,
    Binance = 7,
}